// SalaryComponent.js
import React from 'react';

function SalaryComponent({ salary, setSalary }) {
  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-bold mb-2">Annual Salary</label>
      <div className="flex space-x-4">
        <input
          type="number"
          value={salary.min}
          onChange={(e) => setSalary({ ...salary, min: e.target.value })}
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Min"
        />
        <span className="text-gray-500">to</span>
        <input
          type="number"
          value={salary.max}
          onChange={(e) => setSalary({ ...salary, max: e.target.value })}
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Max"
        />
        <span className="text-gray-500">LPA</span>
      </div>
    </div>
  );
}

export default SalaryComponent;
